// Filename: uimesh.js
// Timestamp: 2017.11.19-13:43:15 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

const getlinesegmenthelper = (THREE, mesh, color = 0x5f5f5f) => (
  new THREE.LineSegments(
    new THREE.EdgesGeometry(mesh.geometry),
    new THREE.LineBasicMaterial({ color, linewidth: 1 })))

const getedgehelper = (THREE, mesh, color) => {
  const linesegmenthelper = getlinesegmenthelper(THREE, mesh, color)

  linesegmenthelper.geometry.scale(0.98, 0.98, 0.98)

  return linesegmenthelper
}

// https://en.wikipedia.org/wiki/Spherical_coordinate_system
// https://github.com/mrdoob/three.js/blob/master/src/math/Spherical.js
const setpositionspherical = (mesh, { radius, phi, theta }) => {
  const sinPhiRadius = Math.sin(phi) * radius

  mesh.position.set(
    sinPhiRadius * Math.sin(theta),
    Math.cos(phi) * radius,
    sinPhiRadius * Math.cos(theta)
  )

  return mesh
}

const setpositioncartesian = (mesh, { x, y, z }) => (
  mesh.position.set(x, y, z) && mesh)

const isvalidsphericalposition = position => Boolean(
  typeof position.radius === 'number' &&
    typeof position.theta === 'number' &&
    typeof position.phi === 'number')

const throw_invalidsphericalposition = position => {
  throw new Error(`invalid spherical position: ${JSON.stringify(position)}`)
}

const setposition = (mesh, spec) => {
  if (spec.postype === 'spherical') {
    mesh = setpositionspherical(mesh, {
      phi: spec.pos[2],
      theta: spec.pos[1],
      radius: spec.pos[0]
    })
  } else if (spec.postype === 'cartesian') {
    mesh = setpositioncartesian(mesh, {
      x: spec.pos[0],
      y: spec.pos[1],
      z: spec.pos[2]
    })
  } else {
    throw new Error('invalid position')
  }

  return mesh
}

export default {
  getlinesegmenthelper,
  getedgehelper,
  setpositionspherical,
  setpositioncartesian,
  isvalidsphericalposition,
  throw_invalidsphericalposition,
  setposition
}
